import styled from 'styled-components'
import { Color } from 'root-constants'

type TContainerProps = {
  isVisible: boolean
}

type TMenu = {
  isMenuVisible: boolean
  backgroundColor: string
}

export const StyledHeader = {
  Wrapper: styled.header`
    position: relative;
    background-color: transparent;
    z-index: 2;
    padding: 0 16px;
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  `,
  SingleWrapper: styled.header`
    position: relative;
    background: var(--header-background-color);
    z-index: 3;
    padding: 0 16px;
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  `,
  LogoContainer: styled.div`
    display: flex;
    align-items: center;
  `,
  LogoText: styled.div`
    padding-left: 6px;
    font-weight: 500;
    font-size: 17px;
    line-height: 23px;
    color: ${Color.WHITE};
    text-shadow: 0 0 10px ${Color.WHITE};
  `,
  PageNumberContainer: styled.div<TContainerProps>`
    min-width: 46px;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
    text-align: right;
  `,
  CurrentPage: styled.span`
    color: ${Color.PRIMARY};
  `,
  PageNumber: styled.span``,
  HeaderActions: styled.div`
    margin-left: 4px;
    display: flex;
    align-items: center;
  `,
  SupportAction: styled.button`
    border: 1px solid ${Color.WHITE};
    border-radius: 42px;
    background-color: transparent;
    padding: 4px 6px;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: ${Color.WHITE};
    margin-right: 16px;
    cursor: pointer;
  `,
  Burger: styled.button`
    width: 20px;
    height: 17px;
    background: transparent;
    border: 0;
    border-radius: 0;
    overflow: hidden;
    position: relative;
    padding: 0;
    cursor: pointer;
  `,
  BurgerLine: styled.span`
    display: block;
    width: 100%;
    height: 2px;
    border-radius: 14px;
    background-color: ${Color.WHITE};
    position: absolute;
    left: 0;
    top: 0;

    &:nth-child(2),
    &:nth-child(3) {
      top: calc(50% - 1px);
    }

    &:last-child {
      top: auto;
      bottom: 0;
    }
  `,
  Backdrop: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(2px);
    z-index: 3;
  `,
  Menu: styled.nav<TMenu>`
    width: 280px;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    background: ${({ backgroundColor }) => backgroundColor};
    position: absolute;
    z-index: 4;
    padding: 80px 24px;
    transition: transform 0.25s;
    transform: ${({ isMenuVisible }) =>
      isMenuVisible ? 'translateX(0)' : 'translateX(100%)'};
  `,
  MenuCloseButton: styled.button`
    width: 30px;
    height: 30px;
    padding: 0;
    cursor: pointer;
    border: none;
    outline: none;
    border-radius: 50%;
    position: absolute;
    background-color: transparent;
    top: 25px;
    left: 18px;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    &::after,
    &::before {
      display: block;
      content: '';
      width: 20px;
      height: 3px;
      background-color: ${Color.WHITE};
      position: absolute;
      top: calc(50% - 1px);
      left: calc(50% - 10px);
      transform: rotate(45deg);
      border-radius: 30px;
    }

    &::before {
      transform: rotate(-45deg);
    }
  `,
  StyledMenuLinkContainer: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 33px;
    margin-bottom: 16px;

    a {
      color: inherit;
    }
  `,
}
